export default {
    PINTEREST: "https://www.pinterest.com/theofficialgiftguide/",
    INSTAGRAM: "https://www.instagram.com/theofficialgiftguide/",
    FACEBOOK :
    "https://www.facebook.com/The-Gift-Guide-1639904302937660/",
    TWITTER: "https://twitter.com/the_gift_guide",
    YOUTUBE: "https://www.youtube.com/channel/UCtN_AEeQFA5NnuiL8D53aCg/"
}